<template>
  <Container>
    <PageHeader :items="items" />

    <h4 class="card-title">Settings</h4>
    <div class="row">
      <div class="col-lg-4 col-sm-6 mb-4">
        <router-link tag="a" to="/settings/prices" class="text-dark">
          <div class="card shadow h-100">
            <div class="card-body">
              <h1 class="text-primary text-center icon-lg my-3"><i class="fas fa-shopping-cart"></i></h1>
              <h3 class="card-title text-center">Prices</h3>
              <p class="mb-4">Add Prices to your Accomodations</p>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-sm-6 mb-4">
        <router-link tag="a" to="/settings/additional_costs" class="text-dark">
          <div class="card shadow h-100">
            <div class="card-body">
              <h1 class="text-primary text-center icon-lg my-3"><i class="fas fa-dollar-sign"></i></h1>
              <h3 class="card-title text-center">Additional Costs</h3>
              <p class="mb-4">Add Add ons to your Accomodations</p>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-sm-6 mb-4">
        <router-link tag="a" to="/settings/discounts" class="text-dark">
          <div class="card shadow h-100">
            <div class="card-body">
              <h1 class="text-primary text-center icon-lg my-3"><i class="fa fa-percent"></i></h1>
              <h3 class="card-title text-center">Discounts</h3>
              <p class="mb-4">Add Discounts to your Accomodations</p>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-sm-6 mb-4">
        <router-link tag="a" to="/settings/rules" class="text-dark">
          <div class="card shadow h-100">
            <div class="card-body">
              <h1 class="text-primary text-center icon-lg my-3"><i class="fa fa-hand-paper"></i></h1>
              <h3 class="card-title text-center">Rules</h3>
              <p class="mb-4">Add Rules to your Accomodations</p>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "./layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";

export default {
  page: {
    title: "Settings",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
    PageHeader,
  },

  data() {
    return {
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Settings",
          active: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
.icon-lg {
  font-size: 70px;
}
</style>
